import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface TimelineEvent {
  label:       string;         // ej. "Día 3"
  value:       number;
  sublabel?:   string;         // texto extra debajo del valor
  highlight?:  boolean;        // marcar como pico / hito
}

export interface DarkTimelineConfig {
  title?:       string;
  headerIcon?:  string;
  valueLabel?:  string;        // unidad del valor, ej: "aprobados"
  accentColor?: string;
  events:       TimelineEvent[];
}

@Component({
  selector: 'app-dark-timeline-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dark-timeline-card.component.html',
  styleUrl:    './dark-timeline-card.component.scss',
})
export class DarkTimelineCardComponent implements OnChanges {
  @Input() config!: DarkTimelineConfig;

  maxValue = 1;

  ngOnChanges(): void {
    this.maxValue = Math.max(...(this.config?.events ?? []).map(e => e.value), 1);
  }

  get accent(): string {
    return this.config?.accentColor ?? 'var(--cc-accent)';
  }

  /** Ancho proporcional de la barra (0-100%) */
  barWidth(value: number): string {
    return `${Math.round((value / this.maxValue) * 100)}%`;
  }

  /** Color de la barra: más brillante si es el pico */
  barColor(event: TimelineEvent): string {
    return event.highlight ? this.accent : 'var(--cc-divider)';
  }

  /** Formatea el valor con separador de miles */
  fmt(value: number): string {
    return value.toLocaleString('es-CO');
  }
}
